import {Col, Row} from "antd";
import styled from "styled-components";
import React from "react";

export const OrderBlockContainer = styled(({isLast, isFromCustomerTheme, ...props}) => (
    <Row {...props} />
))`
    width: 100%;
    border-bottom: ${props => (props.isLast ? "none" : "1px dashed #c6c5c5")};
    flex-direction: column;
    gap: ${props => (props.isFromCustomerTheme ? "4px" : "20px")} !important;
`;

// Customer-specific compact order block container
export const CustomerOrderBlockContainer = styled(({isLast, ...props}) => <Row {...props} />)`
    width: 100%;
    border-bottom: ${props => (props.isLast ? "none" : "1px dashed #c6c5c5")};
    padding: ${props => (props.isLast ? "12px 0 0px 0" : "12px 0 12px 0")};
    flex-direction: column;
    gap: 4px !important;
`;

export const OrderBlockHeader = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
`;

// Customer-specific compact order block header
export const CustomerOrderBlockHeader = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 4px;
`;

export const OrderBlockTitle = styled(Col)`
    font-size: 18px;
    margin-left: 7px;
`;

// Customer-specific compact order block title
export const CustomerOrderBlockTitle = styled(Col)`
    font-size: 16px;
    margin-left: 7px;
`;

export const NoBorderTabs = styled.div`
    .no-tab-border {
        .ant-tabs-nav::before {
            border-bottom: none !important;
        }

        .ant-tabs-tab {
            border-bottom: none !important;
            padding: 4px 12px !important;
            font-size: 12px !important;
            min-height: 28px !important;
            min-width: 80px !important;
            text-align: center !important;
            margin-right: 4px !important;
            border-radius: 4px !important;
            background-color: #f5f5f5 !important;
            border: 1px solid #d9d9d9 !important;
            transition: all 0.2s ease !important;
        }

        .ant-tabs-tab:hover {
            background-color: #e6f7ff !important;
            border-color: #40a9ff !important;
        }

        .ant-tabs-tab-active {
            background-color: #b2fc35 !important;
            border-color: #b2fc35 !important;
        }

        .ant-tabs-tab-btn {
            color: #666 !important;
            font-weight: 500 !important;
            width: 100% !important;
            text-align: center !important;
            line-height: 20px !important;
            font-size: 12px !important;
            padding: 0 !important;
        }

        .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #000 !important;
            font-weight: 600 !important;
        }

        .ant-tabs-content-holder {
            border-bottom: none !important;
        }

        .ant-tabs-nav {
            margin-bottom: 0 !important;
            .ant-tabs-nav-operations {
                display: none !important;
            }
        }

        .ant-tabs-ink-bar {
            display: none !important;
        }
    }
`;
